export default __webpack_public_path__ + "static/media/f_card.6a79370d.svg";